import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { optionName, readField } from '@aid/shared/utils/object-fields';

@Component({
  selector: 'aid-filterable-select',
  template: `
    <mat-form-field class="full-width" color="accent">
      <mat-label>{{ title | translate | titlecase }}</mat-label>
      <mat-select [formControl]="control">
        <div class="filter filter--sticky aid-layout-row">
          <mat-icon
            matPrefix
            class="filter--margin"
            svgIcon="search"
          ></mat-icon>
          <input
            matInput
            placeholder="{{ 'filter' | translate | titlecase }}"
            type="text"
            autocomplete="off"
            [formControl]="filterControl"
            (keydown.Space)="$event.stopPropagation()"
            data-cy="filter"
          />
        </div>
        @for (item of filteredItems | async; track item) {
          <mat-option
            [value]="optionValue(item)"
            data-cy="filterable-option-select"
          >
            {{ displayFn(item) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
  styleUrls: ['./filterable-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilterableSelectComponent<T = unknown> implements OnInit {
  filterControl: UntypedFormControl = new UntypedFormControl();
  filteredItems?: Observable<T[]>;
  options?: T[];

  @Input() title?: string;

  @Input('options') set items(options: T[] | null | undefined) {
    if (options) {
      this.initFilter(options);
      this.options = options;
    }
  }
  @Input({ required: true }) control = new UntypedFormControl();
  @Input() displayFn: (item: T) => string | null | undefined = item =>
    optionName(item);

  constructor() {}

  ngOnInit() {}

  initFilter(options: T[]) {
    this.filteredItems = this.filterControl.valueChanges.pipe(
      startWith(''),
      map(filterBy => (filterBy ? this.filteredBy(filterBy) : options.slice()))
    );
  }

  filteredBy(filterBy: string) {
    if (!this.options) {
      return [];
    }

    return this.options.filter(
      item =>
        (this.displayFn(item) ?? '')
          .toLowerCase()
          .indexOf(filterBy.toLowerCase()) > -1
    );
  }

  optionValue(item: T): unknown {
    return readField(item, 'id');
  }
}
